import { Directive, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
  selector: '[appNumber]'
})
export class NumberDirective {

  @Output() validatorNumber = new EventEmitter<boolean>();
  private regex: RegExp = new RegExp(/^\d+$/);

  constructor() { }

  @HostListener('keypress', ['$event'])
  onKeyPress(event) {
    if (event.key) {
      const inp = event.key;
      if (this.regex.test(inp)) {
        this.validatorNumber.emit(true);
        return true;
      } else {
        event.preventDefault();
      }
    } else {
      this.validatorNumber.emit(true);
      return true;
    }
  }

  @HostListener('blur', ['$event'])
  onBlur(event) {
    if (event.srcElement.value) {
      const inp = event.srcElement.value;
      if (this.regex.test(inp)) {
        this.validatorNumber.emit(true);
        return true;
      } else {
        this.validatorNumber.emit(false);
        return false;
      }
    } else {
      this.validatorNumber.emit(true);
      return true;
    }
  }
}
